import React, { useState, useEffect } from 'react';
// import sc from '../Assets/verify.png'
// import { Link } from 'react-router-dom';
// import { type } from '@testing-library/user-event/dist/type';

const AdmissionForm = () => {
  const [formFields, setFormFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedAcademicYear, setSelectedAcademicYear] = useState("");
  const [standards, setStandards] = useState([]);
  const [selectedStandard, setSelectedStandard] = useState('');
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [yearId, setYearId] = useState(null);
  const [institutionType, setInstitutionType] = useState(null);

  useEffect(() => {
    const fetchFormConfig = async () => {
      try {
        const response = await fetch('https://api.sirajulhuda.com/api/v1/erp/admission-application-config/27');
        const result = await response.json();
        const institutionFormConfigs = result.data.config;

        const institutionTypeField = institutionFormConfigs.find(config => config.column_name === 'type');
        if (institutionTypeField) {
          setInstitutionType(institutionTypeField.default_value);
        }
        console.log('Institution Type:', institutionType);

        const yearIdField = institutionFormConfigs.find(config => config.column_name === 'year_id');  
        if (yearIdField) {
          setYearId(yearIdField.default_value);
        }
        console.log('Year id:', yearId);

        const fieldTypes = {
          str: 'text', standard: 'text', school: 'text',
          ration_card_type: 'text', yes_no: 'select',
          local_body: 'text', int: 'number', date: 'date'
        };

        const numberFields = ['mobile', 'whats_app', 'aadhaar', 'phone', 'father_phone', 'mother_phone', 'pin_code'];

        const updatedFormFields = institutionFormConfigs
          .filter(config => config.visibility === true)
          .map(config => ({
            name: config.column_name,
            title: config.title,
            type: numberFields.includes(config.column_name) ? 'number' : fieldTypes[config.type] || 'text',
            required: config.is_required,
            defaultValue: config.default_value,
            isYesNo: config.type === 'yes_no'
          }));

        setFormFields(updatedFormFields);

        // Fetch standards
        const standardsResponse = await fetch(`https://api.sirajulhuda.com/api/v1/erp/school/standards/list/27`);
        const standardsResult = await standardsResponse.json();
        setStandards(standardsResult.data);

      } catch (error) {
        console.error("Error fetching form config:", error);
        setAlert({ message: "Error loading form. Please try again.", type: 'error' });
      }
    };

    fetchFormConfig();
  }, []);

  // Add a separate useEffect to log updated state values
  useEffect(() => {
    console.log('Updated Year ID:', yearId);
    console.log('Updated Institution Type:', institutionType);
  }, [yearId, institutionType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create submission data with correct standard_id
    const submissionData = {
      institution_id: 27,
      year_id: yearId,
      type: institutionType,
      standard_id: Number(selectedStandard), // Convert to number explicitly
      ...formData
    };
   
    try {
      console.log('Submission data:', submissionData); // Log the submission data
      const response = await fetch('https://api.sirajulhuda.com/api/v1/erp/admission/application/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          'year_id': submissionData.year_id === null ? null : Number(submissionData.year_id),
          'type': submissionData.type === null ? null : submissionData.type,
          'institution_id': submissionData.institution_id === null ? null : Number(submissionData.institution_id),
          'standard_id': submissionData.standard_id === null ? null : Number(submissionData.standard_id),
          'mobile': submissionData.mobile,
          'whats_app': submissionData.whats_app === null ? null : submissionData.whats_app,
          'email': submissionData.email === null ? null : submissionData.email,
          'name': submissionData.name === null ? null : submissionData.name,
          'full_initial': submissionData.full_initial === null ? null : submissionData.full_initial,
          'dob': submissionData.dob ? new Date(submissionData.dob).toISOString().slice(0, 19).replace('T', ' ') : null,
          'word_dob': submissionData.word_dob === null ? null : submissionData.word_dob,
          'gender': submissionData.gender === null ? null : submissionData.gender,
          'blood_group': submissionData.blood_group === null ? null : submissionData.blood_group,
          'religion': submissionData.religion === null ? null : submissionData.religion,
          'caste': submissionData.caste === null ? null : submissionData.caste,
          'aadhaar': submissionData.aadhaar === null ? null : submissionData.aadhaar,
          'mother_tongue': submissionData.mother_tongue === null ? null : submissionData.mother_tongue,
          'house_name': submissionData.house_name === null ? null : submissionData.house_name,
          'local_name': submissionData.local_name === null ? null : submissionData.local_name,
          'local_body': submissionData.local_body === null ? null : submissionData.local_body,
          'ration_card_type': submissionData.ration_card_type === null ? null : submissionData.ration_card_type,
          'pin_code': submissionData.pin_code === null ? null : submissionData.pin_code,
          'post': submissionData.post === null ? null : submissionData.post,  
          'place': submissionData.place === null ? null : submissionData.place,
          'block': submissionData.block === null ? null : submissionData.block,
          'taluk': submissionData.taluk === null ? null : submissionData.taluk,         
          'district': submissionData.district === null ? null : submissionData.district,
          'state': submissionData.state === null ? null : submissionData.state,
          'nationality': submissionData.nationality === null ? null : submissionData.nationality,
          'is_single_girl': true,
          'is_disabled': submissionData.is_disabled === null ? null : submissionData.is_disabled,
          'father_name': submissionData.father_name === null ? null : submissionData.father_name,
          'father_phone': submissionData.father_phone === null ? null : submissionData.father_phone,
          'father_income': submissionData.father_income === null ? null : submissionData.father_income,
          'father_email': submissionData.father_email === null ? null : submissionData.father_email,
          'father_qualification': submissionData.father_qualification === null ? null : submissionData.father_qualification,
          'father_occupation': submissionData.father_occupation === null ? null : submissionData.father_occupation,
          'mother_name': submissionData.mother_name === null ? null : submissionData.mother_name,
          'mother_occupation': submissionData.mother_occupation === null ? null : submissionData.mother_occupation,
          'mother_email': submissionData.mother_email === null ? null : submissionData.mother_email,
          'mother_phone': submissionData.mother_phone === null ? null : submissionData.mother_phone,
          'mother_qualification': submissionData.mother_qualification === null ? null : submissionData.mother_qualification,
          'mother_income': submissionData.mother_income === null ? null : submissionData.mother_income,
          'guardian': submissionData.guardian === null ? null : submissionData.guardian,
          'relationship': submissionData.relationship === null ? null : submissionData.relationship,
          'guardian_address': submissionData.guardian_address === null ? null : submissionData.guardian_address,
          'last_school': submissionData.last_school === null ? null : submissionData.last_school,
          'last_school_affiliation': submissionData.last_school_affiliation === null ? null : submissionData.last_school_affiliation,
          'tc_no': submissionData.tc_no === null ? null : submissionData.tc_no,
          'tc_issue_date': submissionData.tc_issue_date === null ? null : submissionData.tc_issue_date,
          'id_mark': submissionData.id_mark === null ? null : submissionData.id_mark,
          'father_job_title': submissionData.father_job_title === null ? null : submissionData.father_job_title,
        }),
      });

      const result = await response.json();
      console.log('sdfsfsdfsdfsdfsdfsdf');
      console.log('Submission response:', result); // Log the response
      const applicationId = result.applicationId;
      console.log('Application ID:', applicationId);
      if (result.detail === "application existed") {
        setAlert({ message: 'Application already exists!', type: 'error' });
      } else if (result.status === 200 || result.status === 201) {
        const applicationId = result.applicationId;
        console.log('Application ID:', applicationId);
        const submitUrl = `https://api.sirajulhuda.com/api/v1/erp/admission/admission-application/submit/${applicationId}`;
        console.log('Entering')
        const applicationSubmitResponse = await fetch(submitUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        })
          ;
        if (applicationSubmitResponse.status === 200 || applicationSubmitResponse.status === 201) {

          setAlert({ message: 'Application submitted successfully!', type: 'success' });
          setFormData({});
          setSelectedStandard('');
        }
        else {
          // Handle other status codes
          setAlert({ message: result.message || 'Submission failed. Please try again.', type: 'error' });
        }
      } else {
        // Handle other status codes
        setAlert({ message: result.message || 'Submission failed. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setAlert({ message: 'Error submitting application. Please try again.', type: 'error' });
    } finally {
      setIsSubmitting(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    

  };
  return (
    <div className="admission-form-container">
      {alert.message && (
        <div className={`alert ${alert.type === 'error' ? 'alert-danger' : 'alert-success'}`}>
          {alert.message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="admission-form">
        <div className="form-section">

          <div className="form-group">
            <label>
              Select Standard <span className="required">*</span>
            </label>
            <select
              value={selectedStandard}
              onChange={(e) => setSelectedStandard(e.target.value)}
              className="form-control"
              required
            >
              <option value="">Choose a standard</option>
              {standards.map((std) => (
                <option key={std.id} value={std.id}>{std.name}</option>
              ))}
            </select>
          </div>

          {/* <div className="form-group">
            <label>
              Select Academic Year <span className="required">*</span>
            </label>
            <select
              value={selectedAcademicYear}
              onChange={(e) => setSelectedAcademicYear(e.target.value)}
              className="form-control"
              required
            >
              <option value="">Choose Year</option>
              {acadamic_years.map((year) => (
                <option key={year.id} value={year.name}>
                  {year.name}
                </option>
              ))}
            </select>
          </div> */}

          {formFields.map((field) => (
            <div key={field.name} className="form-group">
              <label>
                {field.title}
                {field.required && <span className="required">*</span>}
              </label>
              {field.isYesNo ? (
                <select
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  required={field.required}
                  className="form-control"
                >
                  <option value="">Select Yes/No</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={handleChange}
                  required={field.required}
                  className="form-control"
                  placeholder={`Enter ${field.title}`}
                />
              )}
            </div>
          ))}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className={`submit-button ${isSubmitting ? 'submitting' : ''}`}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Application'}
        </button>
      </form>
    </div>
  );
};

export default AdmissionForm;